module.exports = __webpack_public_path__ + "img/index-about-talent.bb5a6afe.png";